import { Component, Input, OnInit } from '@angular/core'
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'automation-header-info',
  standalone: true,
  imports: [TranslateModule, E11TooltipModule],
  template: `
    <div class="e11-flex e11-gap-1 e11-items-center e11-font-semibold e11-mb-2">
      {{ titleText | translate }}
      <e11-tooltip [color]="'dark-grey'" tooltipText="{{ toolTipText | translate }}">
        <span class="material-icons-outlined e11-text-skin-base md-18">info</span>
      </e11-tooltip>
    </div>
  `,
})
export class AutomationHeaderInfoComponent implements OnInit {
  @Input() toolTipText = 'This is delayed from the time of application submission.'
  @Input() titleText = 'How long do we wait before sending this message?'
  constructor() {}

  ngOnInit() {}
}
